import * as React from "react";

import Button from "@mui/material/Button";
import { cyan } from "@mui/material/colors";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import PhoneIcon from "@mui/icons-material/Phone";
import DraftsIcon from "@mui/icons-material/Email";

import "../public/CSS/Landing.css";

const theme = createTheme({
  palette: {
    primary: {
      main: "#078109ff",
    },
    secondary: {
      main: "#1483f9",
    },
    tertiary: {
      main: "#078109ff",
    },
  },
});

const Landing = () => {
  // WEo
  React.useEffect(() => {
    function _toArray(arr) {
      return Array.isArray(arr) ? arr : Array.from(arr);
    }

    const makeSpans = async (selector) => {
      var _document$querySelect = document.querySelectorAll(selector);
      var _document$querySelect2 = _toArray(_document$querySelect);
      var elements = _document$querySelect2.slice(0);

      return elements.map(function (element) {
        var text = element.innerText.split("");
        var spans = text
          .map(function (letter) {
            return "<span>" + letter + "</span>";
          })
          .join("");
        return (element.innerHTML = spans);
      });
    };
    makeSpans("h5");
  }, []);

  return (
    <div>
      <div className="row row-main">
        <div className="main-img col-sm-12">
          <h1 className="home-title">
            Homes Built With Ingenuity
            <br />
          </h1>
          <p className="home-subtitle">
            Building more than houses — creating lasting homes.
          </p>
          <br />
          <div className="hero-btn-container">
            <ThemeProvider theme={theme}>
              <Button
                href="tel:773-576-3223"
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<PhoneIcon />}
                className="cta-btn"
              >
                Call Us
              </Button>
              <Button
                href="./contact"
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<DraftsIcon />}
                className="cta-btn"
              >
                Message Us
              </Button>
            </ThemeProvider>
          </div>
        </div>
      </div>
      <div className="main-gradient-2"></div>
      <div className="main-pilates-container">
        <div className="main-pilates">
          <h3 className="main-pilates-title">A little about Ingenious...</h3>
          <p class="main-pilates-subtitle">
            <h5>Ingenious Construction</h5> is a <h5>Chicago-based</h5>{" "}
            carpentry company proudly serving communities across{" "}
            <h5>Illinois and Indiana.</h5> Led by our head carpenter,{" "}
            <h5>Pedro</h5>, who brings more than 25 years of hands-on experience
            to every project, we specialize in building quality homes with
            craftsmanship you can see and trust.
          </p>

          <p class="main-pilates-subtitle">
            From solid foundations to the finishing touches, our team combines
            traditional skill with <h5>innovative techniques</h5> to deliver
            results that last. Whether you’re planning a new build or looking to
            bring fresh life to an existing space,{" "}
            <h5>Ingenious Construction</h5> is dedicated to turning your vision
            into a home you’ll love for years to come.
          </p>
          <div className="pilates-cta-btn-2">
            <Button
              href="./"
              variant="contained"
              color="primary"
              size="large"
              className="cta-btn-2"
            >
              Message Us
            </Button>
          </div>
        </div>
      </div>
      <div className="main-gradient-2" />

      <div className="row">
        <div
          className="main-slides-container reverse"
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="600"
        >
          <img
            className="main-slides-img"
            src={require("../../src/public/images/ing-stock-1.jpg")}
            alt=""
          ></img>

          <div className="main-slides-text">
            <p className="main-slides-header">
              <a>Precision</a>
            </p>
            <span className="accent-bar"></span>
            <p>
              Precision is at the core of everything we build. Our team follows
              every blueprint with exacting detail, double-checking every cut
              and measurement to ensure flawless results. With rigorous
              oversight from experienced leaders, we deliver work that meets the
              highest standards — without shortcuts, every time.
            </p>
          </div>
        </div>
      </div>

      <div className="row">
        <div
          className="main-slides-container"
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="600"
        >
          <img
            className="main-slides-img"
            src={require("../../src/public/images/ing-stock-3.jpg")}
            alt=""
          ></img>

          <div className="main-slides-text ">
            <p className="main-slides-header">
              <a>Reliability</a>
            </p>
            <span className="accent-bar"></span>
            <p>
              Reliability is the foundation of our work. We stay on schedule,
              keep the job site clean, and communicate with you every step of
              the way. Our team is committed to meeting deadlines without
              sacrificing quality — delivering results you can count on, every
              time.
            </p>
          </div>
        </div>
      </div>

      <div className="row">
        <div
          className="main-slides-container reverse"
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="600"
        >
          <img
            className="main-slides-img"
            src={require("../../src/public/images/ing-stock-2.jpg")}
            alt="Very nice home as a background image"
          ></img>

          <div className="main-slides-text">
            <p className="main-slides-header">
              <a>Experience</a>
            </p>
            <span className="accent-bar"></span>
            <p>
              With decades of experience and hundreds of framing projects
              completed, our team brings unmatched skill to every build. From
              the smallest detail to the largest structure, we know the trade
              inside and out — giving you peace of mind that your project is in
              the hands of seasoned experts.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
